export function isHttp(link) {
    const re = /https:\/\/|http:\/\//;
    return re.test(link);
}
